import { render, staticRenderFns } from "./AddOCRTemplatePage.vue?vue&type=template&id=3dad58ba&"
import script from "./AddOCRTemplatePage.vue?vue&type=script&lang=js&"
export * from "./AddOCRTemplatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dad58ba')) {
      api.createRecord('3dad58ba', component.options)
    } else {
      api.reload('3dad58ba', component.options)
    }
    module.hot.accept("./AddOCRTemplatePage.vue?vue&type=template&id=3dad58ba&", function () {
      api.rerender('3dad58ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AddOCRTemplatePage.vue"
export default component.exports